module.exports = __webpack_public_path__ + "img/icon-alfresco-highlight.511e9ab4.svg";